import { PORTAL_PAGES_ACTIONS } from './portalPages.types'
import type {
  PortalPageDataAction,
  PortalPagesClearAction,
  PortalPagesErrorsAction,
  PortalPagesSlice,
  PortalPagesStatusAction,
  SliceError
} from './portalPages.types'

export const setPortalPagesStatusAction = (payload: PortalPagesSlice['status']): PortalPagesStatusAction => ({
  type: PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGES_STATUS,
  payload
})

export const setPortalPagesErrorsAction = (payload: SliceError): PortalPagesErrorsAction => ({
  type: PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGES_ERRORS,
  payload
})

export const setPortalPageDataAction = (payload: PortalPageDataAction['payload']): PortalPageDataAction => ({
  type: PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGE_DATA,
  payload
})

export const clearPortalPagesErrorsAction = (): PortalPagesClearAction => ({
  type: PORTAL_PAGES_ACTIONS.CLEAR_PORTAL_PAGES_ERRORS
})

export const clearPortalPagesDataAction = (): PortalPagesClearAction => ({
  type: PORTAL_PAGES_ACTIONS.CLEAR_PORTAL_PAGES_DATA
})
